export default {
  title: "Select by criteria",
  hint: "Pick a task or build relations yourself. You can download the list as CSV or JSON.",
  find: "Search",
  reset: "Clear criteria",
  chooseScenario: "What do you need to find?",
  chooseScenarioHint: "A ready-made catalogue task, or your own set of relations between records.",
  builderTitle: "Build relations yourself",
  builderHint: "Compose criteria by picking record types and the relations between them — without writing a query.",
  builderLoading: "Loading the query builder…",
  configError: "Could not load the query builder. You can write a SPARQL query below.",
  sparql: "SPARQL",
  sparqlSummary: "Query text (SPARQL)",
  sparqlHint: "For specialists. The server accepts SELECT and ASK, at most 1000 rows.",
  runSparql: "Run",
  results: "Results",
  empty: "Nothing matched these criteria.",
  emptyHint: "Widen the year, role or another field and search again.",
  emptyStart: "Choose a task or build relations yourself.",
  askTrue: "True",
  askFalse: "False",
  downloadCsv: "Download CSV",
  downloadJson: "Download JSON",
  save: "Save selection",
  saveCopy: "Save a copy",
  update: "Update query",
  updated: "Query updated",
  untitled: "Untitled selection",
  loginToSave: "Sign in to save",
  saveTitle: "Selection title",
  saved: "Selection saved",
  saveError: "Could not save the query. Your criteria have been preserved.",
  loadingSaved: "Loading saved query…",
  savedUnauthorized: "Sign in to open this saved query.",
  savedNotFound: "The saved query was not found.",
  savedLoadError: "Could not load the saved query.",
  savedInvalid: "This saved item does not contain a valid query.",
  restored: "Loaded “{{title}}”. The query has not been run.",
  unbound: "Not bound",
  placeholder: "SELECT ?title ?year WHERE { … } LIMIT 20",
  colTitle: "Title",
  colCreator: "Author",
  colYear: "Year",
  colPublisher: "Publisher",
  colIdentifier: "ISBN",
  colRecord: "Record",
  fieldPerson: "Person",
  fieldRole: "Role",
  fieldYearFrom: "Year from",
  fieldYearTo: "Year to",
  fieldLanguage: "Language",
  fieldPublisher: "Publisher",
  fieldPlace: "Place of publication",
  fieldConcept: "Subject heading",
  fieldBbk: "BBK",
  fieldUdc: "UDC",
  fieldIdScheme: "Number type",
  fieldIdValue: "Number",
  fieldPrize: "Prize",
  fieldPrizeYear: "Year / season",
  fieldWork: "Work",
  languageAny: "Any",
  languageRus: "Russian",
  languageEng: "English",
  languageDeu: "German",
  languageFra: "French",
  autocompletePlaceholder: "Start typing a name",
  autocompleteEmpty: "Nothing found",
  autocompleteLoading: "Searching…",
  validationRequired: "This field is required",
  validationSubject: "Enter a heading, BBK or UDC",
  runErrorBadRequest: "The query is invalid. Check the fields or SPARQL text.",
  runErrorRateLimit: "Too many requests. Wait a moment and try again.",
  runErrorTimeout: "The query took too long. Narrow the criteria.",
  runErrorUnavailable: "The selection service is temporarily unavailable.",
  roles: {
    author: "author",
    translator: "translator",
    editor: "editor",
    compiler: "compiler",
  },
  schemes: {
    isbn: "ISBN",
    issn: "ISSN",
    doi: "DOI",
    udc: "UDC",
    bbk: "BBK",
    rsl_reg: "RSL registration no.",
    nbr_bib: "NBR record id",
    rsl_bib: "RSL record id",
    nlr_bib: "NLR record id",
  },
  scenarios: {
    author_editions: {
      title: "Author’s editions",
      hint: "Find editions where the selected person has the chosen role.",
    },
    publisher_editions: {
      title: "Publisher’s editions",
      hint: "Find editions from the selected organisation for the given years.",
    },
    subject: {
      title: "By subject or index",
      hint: "Find editions by heading, BBK or UDC.",
    },
    identifier: {
      title: "By number",
      hint: "Find an edition by ISBN, ISSN, DOI, UDC, BBK or system id.",
    },
    prize: {
      title: "Prize laureates",
      hint: "Find nominees and laureates of the selected prize.",
    },
    work_editions: {
      title: "All editions of a work",
      hint: "Find editions of the selected work.",
    },
  },
}
